import React from 'react';
import './App.css';
import {PageContainer} from "./Pages"
import {BrowserRouter} from "react-router-dom"

function App() {
  return (
      <PageContainer/>
  );
}

export default App;
